<template>
    <div>
		<div class="loading" v-if="loading" v-loading="loading"></div>
		<template v-if="!loading">
            <app-table-paginate 
                :routeEdit="routeEdit" 
                :routeDelete="routeDelete" 
                :routeView="routeView" 
                :tableQuery="tableData" 
                :tableColumns="headers"
                :sidebar="true"
                :items="40"
                :multipleSelect="(isAdmin ? true : false)"
                :draggable="(isAdmin ? true : false)"
                :customclass="'table--white'"
                :search="true">
            </app-table-paginate>
            <app-modal-draggable v-if="modalDraggable" :content="tableData" :name="'nombre'" :table="'informes'"></app-modal-draggable>
        </template>
    </div>
</template>

<script>
	import ApiService from '@/common/api.service'
	import tablaConPaginador from '@/components/Dashboard/commons/tablaConPaginador'
	import { mapGetters } from "vuex"
    import modalDraggable from '@/components/Dashboard/Modals/draggable'

    export default {
        name: 'Informes',
        props: ['project'],
        components: {
            'app-table-paginate': tablaConPaginador,
            'app-modal-draggable': modalDraggable            
        },
        computed: {
			...mapGetters(['isAdmin'])
		},
        created () {
            this.$root.$on('sidebarUpdate', (id, element, value) =>  {this.sidebarUpdate(id, value)})
            if(this.isAdmin){
                this.routeView = 'informe/'
                this.routeEdit = '/dashboard/form/informe/'
                this.routeDelete = true
            }else{
                this.routeView = 'informe/'
                this.routeEdit = false
                this.routeDelete = false
            }

			this.init()
			this.$root.$on('delete', (id) => this.eliminarRegistro(id) )
            this.$root.$on('showmodaldraggable', (e) => this.showDraggable() )
            
        },
        data () {
            return  {
				loading: true,
				headers: [
                {
                    'prop': 'icono',
                    'label': 'Icono'
                },
                {
                    'prop': 'nombre',
                    'label': 'Nombre'
                },
                {
                    'prop': 'visible',
                    'label': 'Menú'
                }],
				field: {},
				tableQuery: {},
				routeEdit: null,
                deleterow: false,
                modalDraggable: false
            }
        },
        watch: {
			$route(to) {
				this.loading = true
				this.tableQuery = {}
				this.headers = []
				this.routeEdit = '/dashboard/form/informe/'
				this.init()
			}
		},
        methods: {
			init() {
				this.getTableData()
            },
            nuevoRegistro() {
                this.$router.push('/dashboard/form/informe/')
            },
            async getTableData() {
                if(this.project == '0'){
                    ApiService.post("public/v1", {
                        token: localStorage.getItem("analiticatoken"),
                        single: false,
                        method: 'select',
                        table: 'informes',
                        order: [' informes.order_row']
                    }).then(response => {
                        if(response.data == 'Algo ha fallado'){
                            this.tableData = []
                        }else{
                            let reports_projects;
                            let reports = response.data
                            ApiService.post("public/v1", {
                                token: localStorage.getItem("analiticatoken"),
                                single: false,
                                method: 'select',
                                fields: ['report_id'],
                                table: 'reports_projects'
                            }).then(response => {
                                reports_projects = response.data.map( r => r.report_id )
                                let a = reports.filter( r => {
                                    if(!reports_projects.includes(r.id)){
                                        return r
                                    }
                                })
                                setTimeout(() => {
                                    this.tableData = a.map( i => {
                                        i.visible == 1 ? i.visible = 'Sí' : i.visible = 'No';
                                        return i
                                    })
                                }, 500);
                            })
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 1000);
                    })
                }else{
                    ApiService.post("public/v1", {
                        token: localStorage.getItem("analiticatoken"),
                        single: false,
                        method: 'select',
                        fields: ['informes.id', 'informes.icono', 'informes.url', 'informes.nombre', 'informes.descripcion', 'informes.visible', 'informes.order_row'],
                        inner: [
                            'reports_projects, report_id, id, informes'
                        ],
                        where: ' reports_projects.project_id = ' + this.project,      
                        table: 'informes',
                        order: [' informes.order_row']
                    }).then(response => {
                        if(response.data == 'Algo ha fallado'){
                            this.tableData = []
                        }else{
                            this.tableData = response.data.map( i => {
                                i.visible == 1 ? i.visible = 'Sí' : i.visible = 'No';
                                return i
                            })
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 100);
                    }) 
                }

            },
            async eliminarRegistro (id){
                this.loading = true
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    method: 'DELETE',
                    id: id ,
                    table: 'informes',
                }).then(response => {
                    if(response.data == 1){
                        this.$root.$emit('msgSuccess', 'Registro ELIMINADO')
                        setTimeout(() => {
                            this.init()
                        }, 1000);
                    }else{
                        // this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            },
            async sidebarUpdate(id, value){

                let form = {
                    visible: value
                }
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'UPDATE',
                    id: id,
                    table: 'informes',
                    form: form
                }).then(response => {
                    if(response.data != 'Algo ha fallado' && response.data != "El usuario ya existe"){
                        this.$root.$emit('msgSuccess', 'Registro actualizado')
                        this.loading = true
                        this.init()
                    }
                })
            },
            showDraggable() {
                this.modalDraggable = true
            },
            closeModal(){
                this.$root.$emit('isConnect')                
                this.modalDraggable = false
                this.init()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/InformesProyecto.vue